import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/min/locales';
import axios from '../../../config/axiosInstance';
import { Button, Grid, Typography, Box, Modal, } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ErrorIcon from '@mui/icons-material/Error';
import { usageLog, } from '../../../store/actions/globalActions';
import { result } from 'lodash';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LockIcon from '@material-ui/icons/Lock';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50em',
    height: '550px',
    bgcolor: '#4651e6',
    boxShadow: 24,
    p: 4,
    borderRadius: '2em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#FFFF',
    outline: 'none'
};



const WarningBlocking = (props) => {

    const [dateBloqued, setDateBloqued] = useState('')
    const [isBloquedAccount, setIsBloquedAccount] = useState(false)
    const [isTrial, setIsTrial] = useState(false)
    const [paymentSlip, setPaymentSlip] = useState(null)

    useEffect(() => {
        searchOpenModal();
        // Slip();
    }, [])

    async function searchOpenModal() {

        try {

            const response = await axios.get('/warning')

            if (response.data.dateBloqued) {
                setDateBloqued(response.data.dateBloqued)
                setIsTrial(response.data.isTrial)
                Slip()
            }
            if (response.data.isBloquedAccount && !response.data.isTrial) {
                setIsBloquedAccount(response.data.isBloquedAccount)
                setIsTrial(response.data.isTrial)
                Slip()
            }

        } catch (error) {

        }
    };

    function Slip() {
        const json = JSON.parse(localStorage.companies)
        const companyId = { companyId: json[0].companyId }
        axios.post('/payments/paypal/getBoleto', companyId)
            .then((result) => {
                setPaymentSlip(result.data[0]?.url == undefined ? null : result.data[0]?.url)
            })
            .catch(error => console.log('error', error));
    };
    const companyId = JSON.parse(localStorage.companies)

    return (

        <>
            <Modal
                open={window.location.href.includes('/assinatura') ? false : isBloquedAccount}
                // onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography style={{ marginTop: '10px' }}>
                        <LockIcon style={{ color: 'white', fontSize: '4rem' }} />
                    </Typography>
                    <Typography id="modal-modal-title" variant="h4" component="h2"
                        style={{
                            fontFamily: 'montserrat',
                            fontWeight: 'bold'
                        }}>
                        {'Poxa, acesso bloqueado :('}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} textAlign={'center'} style={{ fontWeight: '500', fontFamily: 'montserrat' }}>
                        Infelizmente, seu acesso à plataforma foi bloqueado<br />
                        por conta de um pagamento pendente que não foi<br />
                        regularizado no prazo estabelecido.
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} textAlign={'center'} style={{ fontWeight: '500', fontFamily: 'montserrat' }}>
                        Mas não se preocupe!<br />
                        Para desbloquear o seu acesso, basta clicar no botão abaixo<br />
                        e sequir as instruções para resolver essa pendência.
                    </Typography>
                    <Button
                        style={{
                            backgroundColor: '#00a000',
                            color: 'white',
                            borderRadius: '20px',
                            width: '339px',
                            height: '50px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            textTransform: 'none',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            padding: '-1px 50px',
                            marginBottom: '-13px',
                            marginTop: '20px'
                        }}
                        href={"https://api.whatsapp.com/send/?phone=5561996894936&text=gostaria%20de%20falar%20sobre%20meu%20acesso%20Premium!&type=phone_number&app_absent=0"}
                        onClick={() => { usageLog("warning/modal/inadimplente/WhatsApp/Suporte", companyId[0].companyId, companyId[0].byUser) }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginLeft: '-21px' }}>
                            FALE COM O SUPORTE
                        </div>
                        <div style={{ marginLeft: '14em', position: 'absolute', marginTop: '10px' }}>
                            <WhatsAppIcon style={{ fontSize: '40px' }} />
                        </div>
                    </Button>
                    <Button
                        // href={isTrial? "/assinatura" : 'https://www.gpay.com.br/landingpage4445368'}
                        href={isTrial ? "/assinatura" : paymentSlip == null ? "/assinatura" : paymentSlip}
                        // onClick={() => {usageLog("inadimplentes/modal/bloqueio/regularisePagamento", companyId[0].companyId)}}
                        style={{
                            backgroundColor: '#ffffff',
                            color: '#4651e6',
                            marginTop: '1em',
                            paddingLeft: '2em',
                            paddingRight: '2em',
                            fontWeight: 'bold',
                            fontFamily: 'montserrat',
                            borderRadius: '1em',
                            fontSize: '20px',
                            padding: '6px 40px'
                        }}>
                        Regularize e libere seu acesso
                    </Button>
                    <Button
                        href="/logout"
                        style={{
                            color: '#ffffff',
                            marginTop: '1em',
                            paddingLeft: '2em',
                            paddingRight: '2em',
                            fontWeight: 'bold',
                            fontFamily: 'montserrat',
                            borderRadius: '2em',
                            border: '1px solid #ffffff'
                        }}>
                        Sair
                    </Button>
                </Box>
            </Modal>

            {dateBloqued != '' && !isBloquedAccount ?
                <Grid container justifyContent='center' style={{ padding: '1em', alignItems: 'center', backgroundColor: '#ba0001', color: '#ffffff' }}>
                    <Grid item style={{ paddingRight: '5em' }}>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item style={{ display: 'flex', textAlign: 'start', alignItems: 'center' }}>
                                <ErrorIcon style={{ color: '#febb2e', marginRight: '0.2em', fontSize: '2em' }} />
                                <Typography variant="body1">Aviso Importante! Ação nescessária até {new Date(dateBloqued.slice(0, -1)).getDate()} de {new Date(dateBloqued).toLocaleString('pt-br', { month: 'long' })} de {moment(dateBloqued).year()}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box sx={{ borderBottom: '40px solid #ffffff', width: '1px' }} />
                    <Grid item style={{ paddingLeft: '5em' }}>
                        <Grid container justifyContent="flex-end">
                            <Grid item style={{ display: 'flex', textAlign: 'start', alignItems: 'center' }}>
                                <Typography variant="body1">
                                    Pagamento pendente! Regularize a situação<br />
                                    para evitar o bloqueio de acesso à plataforma.
                                </Typography>
                                <Button
                                    variant="contained"
                                    // href={isTrial? "/assinatura" : 'https://www.gpay.com.br/landingpage4445368'}
                                    href={isTrial ? "/assinatura" : paymentSlip == null ? "/assinatura" : paymentSlip}
                                    // onClick={() => {usageLog("inadimplentes/modal/aviso/regularisePagamento", companyId[0].companyId)}}
                                    style={{
                                        textTransform: 'none',
                                        height: '20px',
                                        marginLeft: '20px',
                                        borderRadius: '1em',
                                        color: '#ba0001',
                                        backgroundColor: '#febb2e',
                                        fontWeight: '900'
                                    }}>
                                    Regularizar pagamento
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid> : ''
            }
        </>

    );
}


export default WarningBlocking;
